import { render } from "./px-page-header.vue?vue&type=template&id=00d3b3e6&scoped=true&ts=true"
import script from "./px-page-header.vue?vue&type=script&lang=ts"
export * from "./px-page-header.vue?vue&type=script&lang=ts"

import "./px-page-header.vue?vue&type=style&index=0&id=00d3b3e6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00d3b3e6"]])

export default __exports__